var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRotateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.84615 16C4.51284 16 1 12.6421 1 8.5C1 4.35786 4.51284 1 8.84615 1C13.1794 1 16.6923 4.35786 16.6923 8.5C16.6923 9.86174 16.3126 11.1387 15.649 12.2394M15.649 12.2394L19 11.1471M15.649 12.2394L15.3344 12.3419L14.0843 8.83812",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotateIcon);
export default __webpack_public_path__ + "static/media/rotate_icon.febad228f18d6316b430c3e0956c0ddb.svg";
export { ForwardRef as ReactComponent };